export const version = '0.7.0'
export const env = 'dev'